export var VARIANT = {
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};